/* eslint-disable import/no-anonymous-default-export */
export default (approved = [], action) => {
  switch (action.type) {
    case "GET_ALL_APPROVED_INSURANCE":
      return action.payload;

    default:
      return approved;
  }
};
